import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function formatNationalities(nationalities) {
  if (nationalities == null) return "-";
  if (Array.isArray(nationalities)) {
    return nationalities.length > 0 ? nationalities.join("; ") : "-";
  }
  return nationalities === "" ? "-" : String(nationalities);
}

function FBITable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }
    return classes.odd;
  };

  const monitoring_topic_data = props.fbi_data;

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Tipo</TableCell>
            <TableCell className={classes.tableHeader}>Nome da Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Penalidade</TableCell>
            <TableCell className={classes.tableHeader}>Nacionalidades</TableCell>
            <TableCell className={classes.tableHeader}>Descrição</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={getClass(0)}>
            <TableCell className={classes.tableText}>
              {monitoring_topic_data?.type ?? "-"}
            </TableCell>
            <TableCell className={classes.tableText}>
              {monitoring_topic_data?.sanction_name ?? "-"}
            </TableCell>
            <TableCell className={classes.tableText}>
              {monitoring_topic_data?.penalty ?? "-"}
            </TableCell>
            <TableCell className={classes.tableText}>
              {formatNationalities(monitoring_topic_data?.nationalities)}
            </TableCell>
            <TableCell className={classes.tableText}>
              {monitoring_topic_data?.sanction_description ?? "-"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}

export default FBITable;
